import { defineMessages, plural } from "../i18n/core";

// Catálogo de credenciais da organização (ADR 0030): o segredo nunca aparece.
export const credentialsMessages = defineMessages({
  "pt-BR": {
    intro: "Usuário e senha de rede guardados uma vez e usados pelos compartilhamentos. A senha fica cifrada com a chave da organização, só sai do servidor durante um teste ou backup e nunca aparece aqui. Trocar a senha aqui vale para todos os compartilhamentos que a usam.",
    newCredential: "Nova credencial",
    none: "Nenhuma credencial ainda. Cadastre uma para copiar compartilhamentos de rede.",
    colName: "Nome",
    colUser: "Usuário",
    colUsedBy: "Usada por",
    colLastUsed: "Último uso",
    colActions: "Ações",
    usedBy: (n: number) => (n === 0 ? "nenhum compartilhamento" : `${n} ${plural(n, "compartilhamento", "compartilhamentos")}`),
    neverUsed: "nunca",
    kindSmb: "SMB",
    edit: (name: string) => `Editar ${name}`,
    deleteLabel: (name: string) => `Apagar a credencial ${name}`,
    deleteTitle: (name: string) => `Apagar ${name}?`,
    deleteDescription: "Só é possível apagar credencial que nenhum compartilhamento usa. Não tem volta.",
    delete: "Apagar",
    deleted: "Credencial apagada.",
    saved: "Credencial salva.",
    actionFailed: "Não foi possível concluir. Tente de novo.",
    dialogNew: "Nova credencial",
    fieldName: "Nome",
    namePlaceholder: "NAS do escritório",
    fieldKind: "Tipo",
    kindFixed: "Compartilhamento SMB (Windows, NAS).",
    fieldUsername: "Usuário",
    usernameHint: "Como o servidor de arquivos o conhece, sem o domínio.",
    fieldDomain: "Domínio",
    domainHint: "Opcional: o domínio do Active Directory ou o grupo de trabalho.",
    fieldSecret: "Senha",
    secretKeep: "Deixe vazio para manter a senha guardada.",
    secretRequired: "Informe a senha.",
    nameRequired: "Dê um nome à credencial.",
    create: "Cadastrar",
    save: "Salvar",
  },
  "en-US": {
    intro: "Network username and password stored once and used by the shares. The password is encrypted with the organization's key, only leaves the server during a test or backup and never shows here. Changing it here applies to every share that uses it.",
    newCredential: "New credential",
    none: "No credentials yet. Register one to back up network shares.",
    colName: "Name",
    colUser: "Username",
    colUsedBy: "Used by",
    colLastUsed: "Last used",
    colActions: "Actions",
    usedBy: (n: number) => (n === 0 ? "no share" : `${n} ${plural(n, "share", "shares")}`),
    neverUsed: "never",
    kindSmb: "SMB",
    edit: (name: string) => `Edit ${name}`,
    deleteLabel: (name: string) => `Delete credential ${name}`,
    deleteTitle: (name: string) => `Delete ${name}?`,
    deleteDescription: "Only a credential no share uses can be deleted. This cannot be undone.",
    delete: "Delete",
    deleted: "Credential deleted.",
    saved: "Credential saved.",
    actionFailed: "Could not complete. Try again.",
    dialogNew: "New credential",
    fieldName: "Name",
    namePlaceholder: "Office NAS",
    fieldKind: "Type",
    kindFixed: "SMB share (Windows, NAS).",
    fieldUsername: "Username",
    usernameHint: "As the file server knows it, without the domain.",
    fieldDomain: "Domain",
    domainHint: "Optional: the Active Directory domain or the workgroup.",
    fieldSecret: "Password",
    secretKeep: "Leave empty to keep the stored password.",
    secretRequired: "Enter the password.",
    nameRequired: "Give the credential a name.",
    create: "Register",
    save: "Save",
  },
  es: {
    intro: "Usuario y contraseña de red guardados una vez y usados por los recursos compartidos. La contraseña se cifra con la clave de la organización, solo sale del servidor durante una prueba o una copia y nunca aparece aquí. Cambiarla aquí vale para todos los recursos compartidos que la usan.",
    newCredential: "Nueva credencial",
    none: "Todavía no hay credenciales. Registra una para copiar recursos compartidos de red.",
    colName: "Nombre",
    colUser: "Usuario",
    colUsedBy: "Usada por",
    colLastUsed: "Último uso",
    colActions: "Acciones",
    usedBy: (n: number) => (n === 0 ? "ningún recurso compartido" : `${n} ${plural(n, "recurso compartido", "recursos compartidos")}`),
    neverUsed: "nunca",
    kindSmb: "SMB",
    edit: (name: string) => `Editar ${name}`,
    deleteLabel: (name: string) => `Borrar la credencial ${name}`,
    deleteTitle: (name: string) => `¿Borrar ${name}?`,
    deleteDescription: "Solo se puede borrar una credencial que ningún recurso compartido usa. No tiene vuelta atrás.",
    delete: "Borrar",
    deleted: "Credencial borrada.",
    saved: "Credencial guardada.",
    actionFailed: "No se pudo completar. Inténtalo de nuevo.",
    dialogNew: "Nueva credencial",
    fieldName: "Nombre",
    namePlaceholder: "NAS de la oficina",
    fieldKind: "Tipo",
    kindFixed: "Recurso compartido SMB (Windows, NAS).",
    fieldUsername: "Usuario",
    usernameHint: "Como lo conoce el servidor de archivos, sin el dominio.",
    fieldDomain: "Dominio",
    domainHint: "Opcional: el dominio de Active Directory o el grupo de trabajo.",
    fieldSecret: "Contraseña",
    secretKeep: "Déjala vacía para mantener la contraseña guardada.",
    secretRequired: "Indica la contraseña.",
    nameRequired: "Dale un nombre a la credencial.",
    create: "Registrar",
    save: "Guardar",
  },
});
